/**
 * Converts all the alphabetic characters in a string to lowercase.
 */
export function toLowerCase() {
  return (string: string) => string.toLowerCase()
}
